// import React, { createContext } from "react";
// import { io } from "socket.io-client";
// import {
//   WS_URL,
//   TOKEN_NAME,
// } from "constants/index";

// const socket = io(WS_URL, {
//     auth: { token: localStorage.getItem(TOKEN_NAME) },
//   }),
//   SocketContext = createContext(socket);

// socket.on("connect", () => {
//   const msg = `You connected with id: ${socket.id}`;
//   console.log(msg);
// });

// const SocketProvider = ({ children }) => {
//   return (
//     <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
//   );
// };

// export default SocketProvider;
// export { SocketContext };

import React, { createContext } from "react";
import socketio from "socket.io-client";
import { WS_URL, TOKEN_NAME } from "constants/index";

export const socket = socketio.connect(WS_URL, {
  auth: { token: localStorage.getItem(TOKEN_NAME) },
});
export const SocketContext = createContext();
